import Vue from 'vue'
import VueRouter from 'vue-router'

// Личный кабинет
import Index from './views/index.vue'
import Api from './views/api.vue'
import Support from './views/support.vue'
import Settings from './views/settings.vue'
import Contacts from './views/contacts.vue'
import TasksStatistics from './views/tasks/statistics.vue'
import TasksHttp from './views/tasks/http.vue'
import TasksPing from './views/tasks/ping.vue'

// Учетная запись
import Login from './views/account/login.vue'
import Logout from './views/account/logout.vue'
import Registration from './views/account/registration.vue'
import Restore from './views/account/restore.vue'
import Verify from './views/account/verify.vue'

// Страницы ошибок
import PageNotFound from './views/errors/404.vue'

Vue.use(VueRouter)

const routes = [
  // Личный кабинет
  { name: 'index', path: '/', component: Index },
  { name: 'api', path: '/api', component: Api },
  { name: 'support', path: '/support', component: Support },
  { name: 'settings', path: '/settings', component: Settings },
  { name: 'contacts', path: '/contacts', component: Contacts },
  { name: 'tasks/statistics', path: '/tasks/statistics/:id', component: TasksStatistics },
  { name: 'tasks/http', path: '/tasks/http', component: TasksHttp },
  { name: 'tasks/ping', path: '/tasks/ping', component: TasksPing },
  // Учетная запись
  { name: 'account/login', path: '/account/login', component: Login },
  { name: 'account/logout', path: '/account/logout', component: Logout },
  { name: 'account/registration', path: '/account/registration', component: Registration },
  { name: 'account/restore', path: '/account/restore', component: Restore },
  { name: 'account/restore/verify', path: '/account/restore/verify/:code?', component: Verify },
  // Страницы ошибок
  { name: 'errors/404', path: '*', component: PageNotFound },
]

const router = new VueRouter({
  mode: 'history',
  linkActiveClass: 'active',
  base: process.env.BASE_URL,
  routes
})

export default router
